document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector('#hamburger-toggle');
    const mobileMenu = document.querySelector('#menu-main--mobile__wrapper');
    const mobileMenuBodyClass = 'menu-mobile-visible';

    const setMobileMenuState = (isOpen) => {
        if (!mobileMenu || !hamburger) {
            return;
        }

        mobileMenu.classList.toggle('active', isOpen);
        hamburger.classList.toggle('active', isOpen);
        document.body.classList.toggle(mobileMenuBodyClass, isOpen);
    };

    if (hamburger && mobileMenu) {
        hamburger.addEventListener('click', function() {
            const isOpen = !mobileMenu.classList.contains('active');
            setMobileMenuState(isOpen);
        });

        // Keep body class in sync with markup state after any external DOM updates.
        setMobileMenuState(mobileMenu.classList.contains('active'));
    }
});